import { render, staticRenderFns } from "./ExportRDMForm.vue?vue&type=template&id=363d31d8"
import script from "./ExportRDMForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportRDMForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports